<!--

	A testimonial card that displays user's feedback.

-->
<template>
	<div class="mia-Testimonial">
		<inline-svg src="@theme/landingpage/quotes.svg" class="mia-TestimonialQuotes" />
		<h4 class="mia-TestimonialHighlight">
			{{ item.Highlight }}
		</h4>
		<p class="mia-TestimonialText">
			{{ item.Text }}
		</p>
		<div class="mia-TestimonialStars">
			<inline-svg v-for="star in starAmount" :key="star" src="@theme/landingpage/solid_star.svg" />
		</div>
		<p class="mia-TestimonialAuthor">
			{{ item.Author }}
		</p>
	</div>
</template>
<script lang="ts">
import { Component, toNative } from "vue-facing-decorator";
import { MiaPlaza } from "@/Reinforced.Typings";
import { DefaultTestimonial } from "@/Control/Vue/Defaults";
import { Item } from "./Item";
import InlineSvg from "vue-inline-svg";

@Component({
	components: {
		InlineSvg,
	}
})
export class Testimonial extends Item<MiaPlaza.LO.Testimonials.ITestimonial> {
	protected defaults = DefaultTestimonial;

	starAmount = 5;
}

export default toNative(Testimonial);
</script>

<style lang="scss">
$mia-testimonial-box-shadow: 0px 10px 40px 0px rgba(39, 41, 55, 0.12);
$mia-testimonial-line-height: 24px;
$mia-testimonial-text-font-size: 16px;
$mia-testimonial-author-line-height: 28px;
$mia-testimonial-star-color: theme.$mia-color-honeyYellow-300;

.mia-Testimonial {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: theme.$mia-padding-panel-xxl theme.$mia-padding-panel-xl;
	border-radius: theme.$mia-border-radius-big;
	background: theme.$mia-color-panel;
	box-shadow: $mia-testimonial-box-shadow;
	gap: theme.$mia-gap-size-xl;
	height: 100%;
	text-align: center;

	.mia-TestimonialQuotes path {
		fill: theme.$mia-color-landingPage-quotesIcon;
	}

	.mia-TestimonialHighlight {
		display: flex;
		align-items: center;
		justify-content: center;
		min-height: 2 * $mia-testimonial-line-height;
		width: 100%;
	}

	.mia-TestimonialText {
		flex: 1 1 0;
		font-size: $mia-testimonial-text-font-size;
	}

	.mia-TestimonialHighlight, 
	.mia-TestimonialText,
	.mia-TestimonialAuthor {
		line-height: $mia-testimonial-line-height; 
		margin: 0;
	}

	.mia-TestimonialStars {
		display: flex;
		gap: theme.$mia-gap-size;

		svg {
			fill: $mia-testimonial-star-color;
		}
	}

	.mia-TestimonialAuthor {
		color: theme.$mia-color-panel-font-header;
		font-size: theme.$font-size-h4;
		line-height: $mia-testimonial-author-line-height; 
	}
}
</style>
